var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFiles = function SvgFiles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 207,
    height: 95,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B4B4B4",
    d: "M1.836 94.458.75 1.45 65.482.694l1.085 93.009z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "m6.332 14.092 53.803-.628.064 5.46-53.803.628zM9.264 24.28l48.179-.562.059 5.052-48.179.563z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4B4B4",
    d: "m205.834 94.458 1.085-93.008-64.731-.756-1.086 93.009z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "m201.338 14.092-53.803-.628-.064 5.46 53.803.628zM198.406 24.28l-48.179-.563-.059 5.053 48.179.562z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#959595",
    d: "M71.466 94.458V1.443h64.736v93.015z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M76.932 14.15h53.807v5.46H76.932zM79.744 24.372h48.182v5.053H79.744z"
  })));
};
export { SvgFiles as ReactComponent };
export default __webpack_public_path__ + "images/files.svg";